import React, { useState, useEffect, useMemo } from "react";
import "./css/AddOn.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import parse from "html-react-parser";
import { useNavigate, useParams } from "react-router-dom";
import { addItemToCart, removeItemFromCart } from "../slices/signUp";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import ProgressBar from "../components/ProgressBar";

const AddOn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let params = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const products = useSelector((state) => state.products.products);
  const addOnIds = useSelector((state) => state.products.addOnIds);

  useEffect(() => {
    if (
      !addOnIds ||
      addOnIds.length === 0 ||
      !products ||
      addOnIds.length === 0
    ) {
      setIsLoading(true);
      navigate(`/${params.enrollerCode}/enrollment-kit`);
    }
  }, [addOnIds, navigate, products]);

  const cart = useSelector((state) => state.signup.cart);

  const totalItemsInCart = Object.values(cart).reduce(
    (total, item) => total + item.quantity,
    0
  );

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];
    html.setAttribute("data-wf-page", "68603f7a056ff6f78f58cb16");
    html.setAttribute("data-wf-site", "68603f7a056ff6f78f58cab1");
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
  }, []);

  const filteredAddOns = useMemo(() => {
    if (!Array.isArray(products) || !Array.isArray(addOnIds)) return [];
    return products.filter((p) => addOnIds.includes(p.id.toString()));
  }, [products, addOnIds]);

  const checkKeyPress = (e) => {
    if (e?.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const addToCart = (product) => {
    dispatch(addItemToCart(product));
  };

  // Handle Add To Cart Function
  const handleAddToCart = (product) => {
    if (
      !product ||
      !product.prices ||
      product.prices.length === 0 ||
      product.prices[0].price == null
    ) {
      toast.error("This product does not have a valid price.");
      return;
    }
    let currentProduct = selectedProduct.filter((p) => {
      return p.id === product.id;
    });

    if (currentProduct.length === 0 && product?.prices[0]?.price) {
      let store = [...selectedProduct, product];
      setSelectedProduct(store);
      addToCart({
        id: product.id,
        name: product.name,
        price: product.prices[0].price,
      });
    }
  };

  // Remove From Cart Function
  const removeFromCart = (itemId) => {
    setSelectedProduct(
      selectedProduct.filter((p) => {
        return p.id !== itemId;
      })
    );
    dispatch(removeItemFromCart({ id: itemId }));
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 550) {
        setIsMobileDevice(false);
      } else {
        setIsMobileDevice(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fnBack = () => {
    navigate(`/${params.enrollerCode}/enrollment-kit`);
  };

  const fnNavigate = () => {
    navigate(`/${params.enrollerCode}/review`);
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="theme-bg">
        <div className="enrollment-navbar">
          <div className="noa-logo heading-margin"></div>
          <div style={{ display: "flex" }}>
            <button onClick={fnNavigate} className="cartButton">
              <img
                src="/images/cart.png"
                loading="lazy"
                alt=""
                style={{ width: "40px", height: "40px", padding: "0.3rem" }}
              />
              <span aria-label="cart">
                <b>{isMobileDevice ? "" : t("cart")}</b>
              </span>
              {totalItemsInCart > 0 && (
                <span
                  className="basket-count"
                  style={{ top: "-5px", right: "-5px" }}
                >
                  {totalItemsInCart}
                </span>
              )}
            </button>
          </div>
        </div>

        <div className="enrollment-kit-page addon-page">
          <ProgressBar currentStep={"3"} showAddOn={true} />

          <div className="heading space-between">
            <h2 style={{ color: "white", fontSize: "1.9rem" }}>{t("addOn")}</h2>

             {totalItemsInCart > 0 && (
              <div className="navbar-button-wrapper">
                <div className="primary-button-wrapper">
                  <a
                    href="#"
                    onKeyDown={(e) => {
                      checkKeyPress();
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      fnNavigate();
                    }}
                    // className="primary-button w-inline-block"
                    data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                    className="primary-button w-inline-block"
                  >
                    <div className="primary-button-border-wrap">
                      <div className="primary-button-wrap">
                        <div className="primary-button-text">
                          {t("skip")}
                        </div>
                        <div className="primary-button-hover-text">
                          {t("skip")}
                        </div>
                        <div className="primary-button-hover-bg"></div>
                      </div>
                    </div>
                    <div className="line-wrap">
                      <div className="primary-line-wrap _1">
                        <div className="line _1"></div>
                        <div className="line _2"></div>
                      </div>
                      <div className="primary-line-wrap _2">
                        <div className="line _3"></div>
                        <div className="line _4"></div>
                      </div>
                      <div className="primary-line-wrap _3">
                        <div className="line _5"></div>
                        <div className="line _6"></div>
                      </div>
                      <div className="primary-line-wrap _4">
                        <div className="line _7"></div>
                        <div className="line _8"></div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            )}
          </div>

          <div className="addOn-card-container">
            {filteredAddOns.map((product) => (
              <div className="addOn-card" key={product.id}>
                <div className="addOn-upper-card">
                  <img
                    src={
                      product.imageUrl
                        ? product.imageUrl.includes("http")
                          ? `${product.imageUrl}`
                          : `https://sqlvaqdxcel5sg4jky.blob.core.windows.net/documentstorage/${product.imageUrl}`
                        : "/images/noimage.jpg"
                    }
                  />
                </div>
                <div className="addOn-lower-card">
                  <div className="addOn-first-part">
                    <h2>{product.name}</h2>
                    {product.prices.length > 0 ? (
                      product.prices.map((p) => (
                        <div className="addOn-price" key={p.id}>
                          ${p.price ? p.price : "00.0"}{" "}
                          <sub>{t("perMonth")}</sub>
                        </div>
                      ))
                    ) : (
                      <div className="addOn-price">
                        <p>{t("price")}</p>$ 00.0
                      </div>
                    )}
                  </div>
                  <div className="addOn-sec-part">
                    <p>{parse(product.description)}</p>
                  </div>
                  <div className="addOn-third-part">
                    {/* {product.prices.length > 0 ? (
                      product.prices.map((p) => (
                        <div className="addOn-price" key={p.id}>
                          <p>{t("price")}</p>$ {p.price ? p.price : "00.0"}
                        </div>
                      ))
                    ) : (
                      <div className="addOn-price">
                        <p>{t("price")}</p>$ 00.0
                      </div>
                    )} */}

                    <div>
                      {cart[product.id] ? (
                        <div
                          className="primary-button-border-wrap"
                          style={{ width: "100%", cursor: "pointer" }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            removeFromCart(product.id);
                          }}
                        >
                          <div className="inner-button-wrap">
                            <div className="inner-button-text-wrap">
                              <div className="inner-button-text">
                                {t("remove")}
                              </div>
                              <div className="inner-button-hover-text">
                                {t("remove")}
                              </div>
                            </div>
                            <div className="inner-button-hover-bg"></div>
                          </div>
                        </div>
                      ) : (
                        <div className="primary-button-wrapper">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleAddToCart(product);
                            }}
                            className="primary-button w-inline-block"
                          >
                            <div className="primary-button-border-wrap">
                              <div className="primary-button-wrap">
                                <div className="primary-button-text">
                                  {t("addToCart")}
                                </div>
                                <div className="primary-button-hover-text">
                                  {t("addToCart")}
                                </div>
                                <div className="primary-button-hover-bg"></div>
                              </div>
                            </div>
                            <div className="line-wrap">
                              <div className="primary-line-wrap _1">
                                <div className="line _1"></div>
                                <div className="line _2"></div>
                              </div>
                              <div className="primary-line-wrap _2">
                                <div className="line _3"></div>
                                <div className="line _4"></div>
                              </div>
                              <div className="primary-line-wrap _3">
                                <div className="line _5"></div>
                                <div className="line _6"></div>
                              </div>
                              <div className="primary-line-wrap _4">
                                <div className="line _7"></div>
                                <div className="line _8"></div>
                              </div>
                            </div>
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="card-footer-button-wrapper">
            <div className="navbar-button-wrapper">
              <div className="primary-button-wrapper">
                <a
                  href="#"
                  className="inner-button w-inline-block"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    fnBack();
                  }}
                >
                  <div className="primary-button-border-wrap">
                    <div className="inner-button-wrap">
                      <div className="inner-button-text-wrap">
                        <div className="inner-button-text">{t("back")}</div>
                        <div className="inner-button-hover-text">
                          {t("back")}
                        </div>
                      </div>
                      {/* <div className="inner-button-star-wrap">
                        <img
                          loading="lazy"
                          src="/images/inner-button-star-1.svg"
                          alt=""
                          className="inner-button-star _1"
                        />
                        <img
                          loading="lazy"
                          src="/images/inner-button-star-2.svg"
                          alt=""
                          className="inner-button-star _2"
                        />
                        <img
                          loading="lazy"
                          src="/images/inner-button-star-3.svg"
                          alt=""
                          className="inner-button-star _3"
                        />
                      </div> */}
                      <div className="inner-button-hover-bg"></div>
                    </div>
                  </div>
                  <div className="line-wrap-inner">
                    <div className="inner-line-wrap _1">
                      <div className="line"></div>
                      <div className="line _2"></div>
                    </div>
                    <div className="inner-line-wrap _2">
                      <div className="line _3"></div>
                      <div className="line _4"></div>
                    </div>
                    <div className="inner-line-wrap _3">
                      <div className="line _5"></div>
                      <div className="line _6"></div>
                    </div>
                    <div className="inner-line-wrap _4">
                      <div className="line _7"></div>
                      <div className="line _8"></div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="menu-button w-nav-button">
                <div
                  data-is-ix2-target="1"
                  className="hamburger-menu-icon"
                  data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                  data-animation-type="lottie"
                  data-src="/images/hamburger-20menu.lottie"
                  data-loop="0"
                  data-direction="1"
                  data-autoplay="0"
                  data-renderer="svg"
                  data-duration="0"
                  data-ix2-initial-state="0"
                >
                  <span style={{ color: "#ffffff" }}>
                    <img
                      src="/images/Hamburger_icon.png"
                      alt=""
                      style={{ width: "30%" }}
                    />
                  </span>
                </div>
              </div>
            </div>

            {totalItemsInCart > 0 && (
              <div className="navbar-button-wrapper">
                <div className="primary-button-wrapper">
                  <a
                    href="#"
                    onKeyDown={(e) => {
                      checkKeyPress();
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      fnNavigate();
                    }}
                    // className="primary-button w-inline-block"
                    data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                    className="primary-button w-inline-block"
                  >
                    <div className="primary-button-border-wrap">
                      <div className="primary-button-wrap">
                        <div className="primary-button-text">
                          {t("proceedToCheckout")}
                        </div>
                        <div className="primary-button-hover-text">
                          {t("proceedToCheckout")}
                        </div>
                        <div className="primary-button-hover-bg"></div>
                      </div>
                    </div>
                    <div className="line-wrap">
                      <div className="primary-line-wrap _1">
                        <div className="line _1"></div>
                        <div className="line _2"></div>
                      </div>
                      <div className="primary-line-wrap _2">
                        <div className="line _3"></div>
                        <div className="line _4"></div>
                      </div>
                      <div className="primary-line-wrap _3">
                        <div className="line _5"></div>
                        <div className="line _6"></div>
                      </div>
                      <div className="primary-line-wrap _4">
                        <div className="line _7"></div>
                        <div className="line _8"></div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddOn;
